<script setup lang="ts">
import type { LinkShellTextProps } from '.';

const { size = 'md' } = defineProps<LinkShellTextProps>();
defineSlots<{ default: () => void; icon: () => void }>();
</script>

<template>
  <AppText :size class="gap-r2 inline-flex items-center">
    <slot />
    <slot name="icon" />
  </AppText>
</template>
